import { ResponseStatus } from '@sdbn/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { ControlContainer, NgForm } from '@angular/forms';
import { ParamterType, SupplementaryEquipment, TruckDetails } from '../../truck.model';
import { TruckService } from '../../truck.service';

@Component({
  selector: 'app-truck-supplementary-equipment',
  templateUrl: './truck-supplementary-equipment.component.html',
  styleUrls: ['./truck-supplementary-equipment.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class TruckSupplementaryEquipmentComponent implements OnInit {

  @Input() truck = new TruckDetails();

  availableEquipment = new Array<SupplementaryEquipment>();

  constructor(
    private truckService: TruckService,
    public translationService: TranslationService) { }

  ngOnInit(): void {
    // Calculate available equipment which can be handouted
    this.truckService.getAvailableSupplementaryEquipments().subscribe(response => {
      if (response.status === ResponseStatus.SUCCESS) {
        const newAvailableEquipment = new Array<SupplementaryEquipment>();
        if (response.equipments != null) {
          response.equipments.forEach(elm => newAvailableEquipment.push(elm));
        }
        newAvailableEquipment.filter(e => !this.isHandouted(e)).forEach(e => this.availableEquipment.push(e));
      }
    });
  }

  public getSelectedSupplementaryEquipment(): Array<SupplementaryEquipment> {
    const selectedEquipmentToHandout = new Array<SupplementaryEquipment>();
    this.availableEquipment.forEach(e => {
      if (e.selected) {
        selectedEquipmentToHandout.push(e);
      }
    });
    return selectedEquipmentToHandout;
  }

  isStringParameter(se: SupplementaryEquipment) {
    return se.parameter1Type === ParamterType.STRING;
  }

  isNumberParameter(se: SupplementaryEquipment) {
    return se.parameter1Type === ParamterType.NUMBER;
  }


  private isHandouted(equipment: SupplementaryEquipment): boolean {
    for (const ae of this.truck.equipment) {
      if (ae.key === equipment.key) {
        return true;
      }
    }
    return false;
  }

  getSeCbxName(se: SupplementaryEquipment) {
    return 'se_cbx_' + se.key;
  }

  getSeValueName(se: SupplementaryEquipment) {
    return 'se_value_' + se.key;
  }
}
